import 'choerodon-ui/lib/style/index.less';
// style dependencies
import '../../trigger-field/style';
import '../../spin/style';
import 'choerodon-ui/lib/menu/style';
import 'choerodon-ui/lib/checkbox/style';
import './index.less';
